import { programIcon, programLabel } from "./vocabulary"

// match-rate-matrix/ in the shape MatchRateGrid draws: a column per program (with its logo), a
// row per channel, a cell per program in the same order.
export const toMatchRateGrid = (matrix) => ({
  cols: (matrix?.programs ?? []).map((program) => ({
    key: program,
    label: programLabel(program),
    icon: programIcon(program)
  })),
  rows: (matrix?.rows ?? []).map((row) => ({
    key: row.channel,
    label: row.label,
    cells: row.cells.map((cell) => ({
      col: cell.program,
      rate: cell.match_rate,
      matched: cell.matched_count,
      lookups: cell.lookups_count
    }))
  }))
})
